import { CargoCriar } from "./cargo-criar";

export class CargoCorrigirDados extends CargoCriar {
  justificativaCorrecao: string | null;

  constructor(obj?: any) {
    super(obj);
    this.justificativaCorrecao = obj?.justificativaCorrecao ?? null;
  }
}
